import { call, put, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "./servicesPostActions";

function* servicesPost(action) {
  try {
    let response = yield call(
      requestWithSubTenantIfNeeded,
      "post",
      "services",
      { json: action.data }
    );

    yield put(actions.requestSuccess(response.data));

    if (action.resolve) {
      // Pass the created SharedObject back to the caller so inline-create flows
      // (e.g. Host Firewall ServicesDrawer) can grab the real id without
      // round-tripping through the reducer. Backward compatible — existing
      // callers that ignored the resolve arg keep working.
      yield call(action.resolve, response.data);
    }
  } catch (error) {
    yield put(actions.requestFailure(error));

    if (action.reject) {
      yield call(action.reject, error);
    }
  }
}

function* saga() {
  yield takeEvery(actions.SERVICES_POST_REQUEST, servicesPost);
}

export default saga;
